import xhr from 'Common/utils/xhr'
import { getRandomVideosUrl } from '../../endpoints'

/**
 *
 * @param {object} [config={}]
 * @param {number} config.page
 * @param {number} config.limit default 12
 * @returns {object[]} videos - an array of {config.limit} random videos
 */
const getRandomVideos = ({ page = 1, limit = 12 } = {}) =>
  xhr({
    url: getRandomVideosUrl({ page, limit }),
    method: 'get',
  })

export default getRandomVideos
